export const namespace = 'onboarding';
